/* eslint no-shadow: ["error", { "allow": ["state", "getters"] }] */
/* eslint object-curly-newline: ["error", { "multiline": true }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import lodash from 'lodash';

// initial state
const state = {
  messages: [],
};

// getters
const getters = {
  messages: state => state.messages,
  displayMessages: state => lodash.reject(state.messages, message => message.dismissed === true),
};

// actions
const actions = {
  addMessage({ commit }, payload) {
    commit('ADD_MESSAGE', payload);
  },
  dismissMessage({ commit }, payload) {
    commit('DISMISS_MESSAGE', payload);
  },
  removeMessage({ commit }, payload) {
    commit('REMOVE_MESSAGE', payload);
  },
};

// mutations
const mutations = {
  ADD_MESSAGE(state, payload) {
    state.messages.push({ id: (new Date()).getTime() + Math.random(100000, 900000), ...payload });
  },
  DISMISS_MESSAGE(state, payload) {
    const message = lodash.find(state.messages, { id: payload.id });
    if (message) {
      message.dismissed = true;
    }
  },
  REMOVE_MESSAGE(state, payload) {
    state.messages = lodash.reject(state.messages, message => message.id === payload.id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
